<div class="flex-col height100p">
    <sm-toolbar>
        <p-button icon="fas fa-run" label="Holen" (onClick)="getServerInfo()"></p-button>
    </sm-toolbar>
    <textarea pInputTextarea spellcheck=false class="flex-item-fill overflow-y-auto width100p height100p monospace no-resize" *ngIf="serverInfo != null" [autoResize]=false [ngModel]="serverInfo"></textarea>
</div>
